<main id="main-content" class="main-content">
    <h2 class="form-header">3. Watershed Condition</h2>

    <mat-card [formGroup]="form" style="padding-bottom: 24px;">
        <div class="text-div">
            <h2 style="font-weight: 700; font-size: 17px; margin-bottom: 5px;" id="soil-burn-severity-heading">Soil Burn Severity</h2>
            <b>Burn Severity (acres)</b>
            <br>
            <span class="gray-text">Burn severity acres by ownership</span>
        </div>
        <!-- TABLE Ownership -->
        <div class="table-container">
            <table aria-labelledby="soil-burn-severity-caption soil-burn-severity-heading">
                <caption id="soil-burn-severity-caption" class="usa-sr-only">
                  Soil Burn Severity.
                </caption>
                <tr class="table-header">
                    <th>Category</th>
                    <th class="right">Developed</th>
                    <th class="right">Unburned/<wbr>Very Low</th>
                    <th class="right">Low</th>
                    <th class="right">Moderate</th>
                    <th class="right">High</th>
                    <th scope="col" class="right" style="min-width: 110px;">Total Acres</th>
                </tr>
                <ng-container>
                    <ng-container *ngFor="let soil of report().soil_burn_severities; let i = index">
                        <tr class="table-row">
                            @if (soil.ownership == "Other Federal") {
                            <td style="width: 70%" class="text-cell" style="display: flex; height: 70px">
                                <div class="vert-center">{{ soil.ownership }}</div>
                                <div class="vert-center">
                                    <mat-icon
                                        matTooltip='Other Federal: ARMY, BIA, BLM, BOP, BPA, DOD, DOE, DOI, DOT, FHA, FWS, GSA, VA, USPS, USMC, USDA, USCG, USAF, USACE, USBR, OTHFE, HHS, IBWC, LG, NAVY, NOAA, NPS, NTVALL, NTVPIC'
                                        matTooltipClass="tooltipClass"
                                        class="info-blue-header fa-regular fa-circle-info">info_outline</mat-icon>
                                </div>
                            </td>
                            } @else if (soil.ownership == "Private") {
                            <td style="width: 70%" class="text-cell" style="display: flex; height: 70px">
                                <div class="vert-center">{{ soil.ownership }}</div>
                                <div class="vert-center">
                                    <mat-icon matTooltip='Private or Undetermined' matTooltipClass="tooltipClass"
                                        class="info-blue-header fa-regular fa-circle-info">info_outline</mat-icon>
                                </div>
                            </td>
                            } @else {
                            <td style="width: 70%" class="text-cell">
                                {{ soil.ownership }}
                            </td>
                            }
                            <td class="text-cell right">
                                {{ soil.burn_acres_developed ? (soil.burn_acres_developed | number: '1.0-0') : '--' }}
                            </td>
                            <td class="text-cell right">
                                {{ soil.burn_acres_unburned ? (soil.burn_acres_unburned | number: '1.0-0') : '--' }}
                            </td>
                            <td class="text-cell right">
                                {{ soil.burn_acres_low ? (soil.burn_acres_low | number: '1.0-0') : '--' }}
                            </td>
                            <td class="text-cell right">
                                {{ soil.burn_acres_moderate ? (soil.burn_acres_moderate | number: '1.0-0') : '--' }}
                            </td>
                            <td class="text-cell right">
                                {{ soil.burn_acres_high ? (soil.burn_acres_high | number: '1.0-0') : '--' }}
                            </td>
                            <td class="right sum-column">
                                {{categoryTotal(soil.ownership) | number: '1.0-0' }}
                            </td>
                        </tr>
                    </ng-container>
                    <tr class="sum-row">
                        <td class="text-cell">
                            Total Acres
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_developed', false) | number: '1.0-0' }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_unburned', false) | number: '1.0-0' }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_low', false) | number: '1.0-0' }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_moderate', false) | number: '1.0-0' }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_high', false) | number: '1.0-0' }}
                        </td>
                        <td class="right sum-column">
                            {{categoryTotal('total') | number: '1.0-0' }}
                        </td>
                    </tr>
                    <tr class="sum-row">
                        <td class="text-cell">
                            SBS % of NFS
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_developed', true) / (sumAcresBurned('burn_acres_developed', false) || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_unburned', true) / (sumAcresBurned('burn_acres_unburned', false) || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_low', true) / (sumAcresBurned('burn_acres_low', false) || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_moderate', true) / (sumAcresBurned('burn_acres_moderate', false) || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_high', true) / (sumAcresBurned('burn_acres_high', false) || 1) | percent }}
                        </td>
                        <td class="right sum-column">
                            {{categoryTotal('nfs') / categoryTotal('total') | percent }}
                        </td>
                    </tr>
                    <tr class="sum-row">
                        <td class="text-cell">
                            SBS % of Fire
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_developed', false) / (categoryTotal('total') || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_unburned', false) / ( categoryTotal('total') || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_low', false) / ( categoryTotal('total') || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_moderate', false) / ( categoryTotal('total') || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ sumAcresBurned('burn_acres_high', false) / ( categoryTotal('total') || 1) | percent }}
                        </td>
                        <td class="right">
                            {{ 1 | percent }}
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>

        <div class="text-div">
            <b>Soil Burn Severity</b>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().burn_severity_description || '--')"></div>
        <view-image [supporting_files]="report().supporting_files"
            section="3" question="burn_severity"></view-image>

        <div class="text-div">
            <b>Soil Erosion Hazard and Anticipated Response</b>
            <br>
            <span class="gray-text">Please describe the erosion hazard and/or potential of the burned area, including
                the anticipated change of erosion and sedimentation response due to the fire.</span>
        </div>
        <div class="text" [innerHTML]="customATOB(this.report().erosion_potential || '--')"></div>
        <view-image [supporting_files]="report().supporting_files"
            section="3" question="soil_erosion"></view-image>

        <div class="text-div">
            <b>Debris Flow Potential</b>
            <br>
            <span class="gray-text">Please describe the debris flow hazard and potential of the burned area, including
                any interpretation of the USGS Post-fire Debris Flow Hazards model.</span>
        </div>

        <div class="text" [innerHTML]="customATOB(this.report().debris_potential || '--')"></div>
        <view-image [supporting_files]="report().supporting_files"
            section="3" question="debris_flow"></view-image>

        <div class="text-div">
            <b>Estimated Vegetative Recovery Period (years)</b>
            <br>
            <span class="gray-text">Please describe the period of time, in years, that is anticipated for the burned
                area to recover vegetation to recover sufficient to reduce runoff and erosion potential (approximately
                60% ground cover). This is a best estimate of natural
                regeneration.</span>
        </div>

        <div class="text" [innerHTML]="customATOB(this.report().vegetative_recovery || '--')"></div>
        <view-image [supporting_files]="report().supporting_files"
            section="3" question="vegetation_rec"></view-image>

        <div class="text-div">
            <b>Estimated Hydrologic Response</b>
            <br>
            <span class="gray-text">Provide a brief narrative that describes the predicted hydrologic response due to
                post-fire conditions within the burned
                area. Also describe the predicted storm type and time of year of the first damaging storm.</span>
        </div>

        <div class="text" [innerHTML]="customATOB(this.report().hydrolic_response || '--')"></div>
        <view-image [supporting_files]="report().supporting_files"
            section="3" question="hydrologic_res"></view-image>

    </mat-card>
</main>

<ng-template #gisWarn>
    <div class="yellow-warning">
        <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
        <div class="support-text">
            <b>Data source:</b> GIS data. Manual edits made below will be overwritten when GIS data is updated.
        </div>
    </div>
</ng-template>
